import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import { MatButtonToggleChange } from "@angular/material/button-toggle";

@Component({
  selector: "app-order-type-filter",
  templateUrl: "./order-type-filter.component.html",
  styleUrls: ["./order-type-filter.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderTypeFilterComponent implements OnInit {
  @Output() triggerChange: EventEmitter<string> = new EventEmitter();

  selectedType: string = "2";

  constructor() {}

  ngOnInit(): void {}

  onTypeChange(event: MatButtonToggleChange): void {
    this.selectedType = event?.value;
    this.triggerChange.emit(event?.value);
  }
}
